interface MetricCard {
  label: string;
  value: string | number;
  unit?: string;
  sub?: string;
  status?: "normal" | "warning" | "critical";
  icon?: string;
}

interface MetricCardRowProps {
  metrics: MetricCard[];
}

export default function MetricCardRow({ metrics }: MetricCardRowProps) {
  const statusDot = (status?: string) => {
    if (status === "critical")
      return <span className="w-2 h-2 rounded-full bg-red-500 inline-block" />;
    if (status === "warning")
      return <span className="w-2 h-2 rounded-full bg-yellow-500 inline-block" />;
    return <span className="w-2 h-2 rounded-full bg-green-500 inline-block" />;
  };

  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3 mb-5">
      {metrics.map((m, idx) => (
        <div
          key={idx}
          className="rounded-xl border border-gray-100 bg-white px-4 py-3.5 transition-colors hover:border-gray-200"
        >
          <div className="flex items-center justify-between mb-1.5">
            <span className="text-xs text-gray-500">{m.label}</span>
            {m.status && statusDot(m.status)}
            {m.icon && !m.status && (
              <span className="w-4 h-4 flex items-center justify-center text-gray-400">
                <i className={`${m.icon} text-sm`}></i>
              </span>
            )}
          </div>
          <div className="flex items-baseline gap-1">
            <span className="text-lg font-bold text-gray-900">{m.value}</span>
            {m.unit && <span className="text-xs text-gray-400">{m.unit}</span>}
          </div>
          {m.sub && <p className="text-xs text-gray-400 mt-1">{m.sub}</p>}
        </div>
      ))}
    </div>
  );
}
